import React from 'react';
import './App.css';
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { AuthProvider } from './Authentication/AuthProvider';
import Routes from './router/routes';
import { connect } from "react-redux";

function App(props) {
  return (
    <>
      <div className="full-height" style={{ width: "100%" }}>
        <AuthProvider>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </AuthProvider>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {

  }
}

export default connect(mapStateToProps, null)(App);
